import Swiper from 'swiper';
import BaseFeature from '../../foundation/base/base';
import TemplateLoader from '../../foundation/template-loader/template-loader';

class Questionnaire extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.viewport = this.el.querySelector('[data-ref="questionnaire__viewport"]');
		this.prev = this.el.querySelector('[data-ref="questionnaire__prev"] button');
		this.progress = this.el.querySelector('[data-ref="questionnaire__progress"]');
		this.cards = this.el.querySelector('[data-ref="questionnaire__cards"]');
		this.cardTemplate = this.el.querySelector('[data-ref="questionnaire__cardTemplate"]');
		this.answerTemplate = this.el.querySelector('[data-ref="questionnaire__answerTemplate"]');
		this.currentAnswer = '';
		this.answerCollection = [];
		this.resetButton = this.el.querySelector('[data-ref="questionnaire__reset"] button');

		// Swiper configuration
		this.config = {
			init: false,
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			navigation: {
				prevEl: this.prev,
			},
			preventInteractionOnTransition: true,
			a11y: {
				prevSlideMessage: 'Forrige',
				nextSlideMessage: 'Næste',
			},
			grabCursor: true,
			slidesPerView: 1,
			autoHeight: true,
			on: {
				activeIndexChange: () => {
					const card = this.swiper.slides[this.swiper.activeIndex];
					const { progress } = card.dataset;
					const progressMeter = this.progress;
					progressMeter.style.setProperty('--progress', progress);
				},
				slidePrevTransitionEnd: () => {
					this.removeCard();
					this.publish('Questionnaire.hideResults');
				}
			}
		};

		this.init();
	}

	init() {
		this.swiper = new Swiper(this.viewport, this.config);

		// Initialize manually, otherwise init function won't hold reference to swiper
		this.swiper.init();

		this.addCard(this.buildCard(this.settings.StartQuestion), true);

		this.resetButton.addEventListener('click', () => {
			this.reset();
		});

		this.subscribe('Questionnaire.hasLoaded', () => {
			this.log('Questionnaire.hasLoaded');
			this.setState('loaded');
		});
	}

	initCard(card) {
		const cardAnswers = card.querySelectorAll('button');

		cardAnswers.forEach((element, index) => {
			element.addEventListener('click', () => {
				this.currentAnswer = card.cardData.Answers[index].Id;
				this.answerCollection.push(this.currentAnswer);
				this.log(this.answerCollection);

				const nextQuestion = card.cardData.Answers[index].NextQuestion;
				if (nextQuestion) {
					this.addCard(this.buildCard(card.cardData.Answers[index].NextQuestion));
					this.swiper.slideNext();
				} else {
					this.publish('Questionnaire.getResults', this.answerCollection);
					this.setState('loading');
					this.setState('complete');
				}
			});
		});
	}

	buildCard(data) {
		const dataObj = data;
		const answersFragment = TemplateLoader(this.answerTemplate, dataObj.Answers);
		dataObj.answers = answersFragment.htmlString;

		const cardFragment = TemplateLoader(this.cardTemplate, dataObj).htmlFragment;
		cardFragment.cardData = data;

		return cardFragment;
	}

	addCard(htmlFragment, empty = false) {
		const cardFragment = htmlFragment;

		if (empty) {
			this.cards.replaceChildren();
		}

		this.cards.appendChild(cardFragment);

		// When using a document fragment appendChild returns empty fragment
		// so we have to use lastElement Child of the parent
		// and transfer the data object
		const lastCard = this.cards.lastElementChild;
		lastCard.cardData = cardFragment.cardData;

		this.initCard(lastCard);
		this.swiper.update();
	}

	removeCard() {
		this.answerCollection.pop();
		this.log(this.answerCollection);
		this.cards.removeChild(this.cards.lastElementChild);
		this.swiper.update();
	}

	setState(state) {
		if (state === 'loading') {
			this.el.classList.remove('has-loaded');
			this.el.classList.add('is-loading');
		}

		if (state === 'loaded') {
			this.el.classList.remove('is-loading');
			this.el.classList.add('has-loaded');
		}

		if (state === 'complete') {
			this.el.classList.add('is-complete');
		}

		if (state === 'reset') {
			this.el.classList.remove('is-complete');
		}
	}

	reset() {
		this.addCard(this.buildCard(this.settings.StartQuestion), true);
		this.answerCollection = [];
		this.setState('reset');
		this.publish('Questionnaire.hideResults');
	}
}

export default Questionnaire;
